import type { FaireProductEntity } from "../../entity_types/product";

export const p_w9wv6w63y6: FaireProductEntity = {
  token: "p_w9wv6w63y6",
  type: "product",
  name: "Dainty Monstone Ring Celestial Ring Minimalist Crystal Ring Statement Ring Adjustable Ring Stacking Ring Girlfriend Gift R-340",
  brandToken: "b_374b66mxaz",
  brandName: "Aim Eternal",
  imageUrl:
    "https://cdn.faire.com/fastly/259cf1fa2d8c767f2657f13b4a42bcc11b57101e461a320c2f0d50ec3024e3b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f27796f368dad56cedc5fd51076fefbe60f0b21972724ef21bb27c40916e4906.jpeg",
    "https://cdn.faire.com/fastly/439b5bdbcfcabafd74f8d152e086624237857653f071df047d0374c031188107.jpeg",
    "https://cdn.faire.com/fastly/0e5700f014d1fc3147cf366fb6a269d8f1ba987f3f043f7bc33802165c61327e.jpeg",
  ],
  priceDollars: 7.62,
  description: "Theme: Gemstone & Birthstones\n\n",
  tags: [],
  msrpDollars: 15.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:39.401Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
